import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '../../models/menu-item';
import { valueOrNull } from '@web/utils';

@Component({
  selector: 'app-menu-item-router-link',
  imports: [RouterLinkActive, RouterLink],
  templateUrl: './menu-item-router-link.component.html',
  styleUrls: ['./menu-item-router-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemRouterLinkComponent {
  @Input({ required: true }) public item!: MenuItem;

  protected readonly valueOrNull = valueOrNull;
}
